import Item from './Item';
import ItemSelected from './ItemSelected';
import ListSelect from './List';

ListSelect.ItemSelected = ItemSelected;
ListSelect.Item = Item;

export default ListSelect;
